export var multipleSkuLabel = function(strictLocalize) {
    return strictLocalize({
        id: "Bwb4Ev",
        defaultMessage: [
            {
                type: 0,
                value: "SKUs"
            }
        ]
    });
};
export var expandButtonLabel = function(strictLocalize) {
    return strictLocalize({
        id: "gENogC",
        defaultMessage: [
            {
                type: 0,
                value: "See All"
            }
        ]
    });
};
export var collapseButtonLabel = function(strictLocalize) {
    return strictLocalize({
        id: "8BElLV",
        defaultMessage: [
            {
                type: 0,
                value: "See Less"
            }
        ]
    });
};
